<template>
    <div id="Search">
        <main style="min-height: 500px">
            <h1 class="header">貨件查詢</h1>
            <div class="search">
                <h3>請輸入提單號：</h3>
                <input name="key" type="text" v-model="current_number" @keypress.enter="search()"/>
                <div class="input"><input type="submit" :value="is_loading? '搜尋中...':'確 認'" @click.prevent="search()" /></div>
                <div class="error" v-if="error" style="color: red;text-align: center;">
                    <h3>{{ error }}</h3>
                </div>
            </div>

            <div class="search-con" v-if="core_waybill">
                <div class="search-l">
                    <h2 class="t">進口貨件物流狀況</h2>
                    <div class="c">
                        <div class="input"><span>提單日期</span>：<p>{{ human_time(core_waybill.created_at) }}</p></div>
                        <div class="input"><span>訂單號碼</span>：<p>{{ core_waybill.original_number || '-'  }}</p></div>
                        <div class="input"><span>提單號碼</span>：<p>{{ core_waybill.number }}</p></div>
                        <div class="input"><span>追蹤號碼</span>：<p>{{ core_waybill.tracking_number || '-'  }}</p></div>
                        <!-- <div class="input"><span>收&nbsp;件 &nbsp;人</span>：<p>{{ core_waybill.consignee_company_name }} {{ core_waybill.consignee_name }}</p></div> -->
                        <!-- <div class="input"><span>貨品內容</span>：<p>{{ core_waybill.goods_name || '-' }}</p></div> -->
                        <div class="input"><span>件 &nbsp;  &nbsp;數</span>：<p>{{ core_waybill.piece || '1' }}</p></div>
                        <div class="input" v-if="core_waybill.parent_core_waybills.length > 0">
                            <span>包 &nbsp;  &nbsp;裝</span>：
                            <p v-for="(parent_core_waybill, index) in core_waybill.parent_core_waybills">
                                <a  @click="search(parent_core_waybill.number)" class="pointer">
                                    <p class="inline" v-if="parent_core_waybill.material.class_name == 'House'">{{ parent_core_waybill.number }}</p>
                                    <p class="inline" v-else>{{ parent_core_waybill.original_number }}</p>
                                    <p class="inline" v-if="parent_core_waybill.latest_status">({{ parent_core_waybill.latest_status.name }})</p>
                                    <p v-if="core_waybill.parent_core_waybills.length > 1 && index < core_waybill.parent_core_waybills.length - 1">、</p>
                                </a>
                            </p>
                        </div>
                        <div class="input" v-if="core_waybill.child_core_waybills.length > 0">
                            <span>子 &nbsp;  &nbsp;單</span>：
                            <p v-for="(child_core_waybill, index) in core_waybill.child_core_waybills">
                                <a  @click="search(child_core_waybill.number)" class="pointer">
                                    {{ child_core_waybill.original_number }}
                                    <p class="inline" v-if="child_core_waybill.latest_status">({{ child_core_waybill.latest_status.name }})</p>
                                    <p v-if="core_waybill.child_core_waybills.length > 1 && index < core_waybill.child_core_waybills.length - 1">、</p>
                                </a>
                            </p>
                        </div>
                        <div class="input"><span>配送備註</span>：<p>{{ core_waybill.shipping_note || '-' }}</p></div>
                    </div>
                    <div class="table-line">
                        <table>
                            <thead>
                                <th>訊息時間</th>
                                <th>狀態</th>
                                <th>站所簡稱</th>
                                <th>物流訊息</th>
                            </thead>
                            <tbody>
                                <tr v-for="status in core_waybill.statuses">
                                    <td>{{ human_time(status.created_at) }}</td>
                                    <td>{{ status.name }}</td>
                                    <td>{{ status.location }}</td>
                                    <td>{{ status.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="search-r">
                    <h4 class="t">已查閱過的<br/>提單號碼列表</h4>
                    <div class="item">
                        <a href="#" @click.prevent="toggle_current_number(number)" v-for="number in searched_numbers">{{ number }}</a>
                    </div>
                    <h4 class="reset" @click.prevert="reset_searched_numbers()">全部清空</h4>
                </div>
            </div>
        </main>
        <footer>
            <div class="footer">
                <a>電話：03-322-2865</a>
                <a style="float: right;">Email：twn-cbel@parisigs.com</a>
            </div>
        </footer>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment-with-locales-es6';
export default {
    name: 'Search',
    data() {
        return {
            is_loading: false,
            current_number: null,
            searched_numbers: [],
            core_waybill: null,
            error: null
        }
    },
    mounted(){
        if (this.$route.query.number) {
            this.current_number = this.$route.query.number;
            this.search();
        }
        if (this.$route.params.number) {
            this.current_number = this.$route.params.number;
            this.search();
        }
    },
    methods: {
        async search(number = undefined) {
            if (number) {
                this.current_number = number;
            }
            if (this.current_number && !this.is_loading) {
                try {
                    await new Promise(resolve => {
                        this.is_loading = true;
                        this.error = null;
                        this.searched_numbers.push(this.current_number);
                        this.searched_numbers = _.uniq(this.searched_numbers);
                        resolve();
                    });
                    await new Promise(resolve => {
                        this.core_waybill = null;
                        resolve();
                    });
                    await this.search_core_waybill();
                    await this.search_by_express_core_waybill();
                    await new Promise(resolve => {
                        this.current_number = null;
                        this.is_loading = false;
                        resolve();
                    });
                } catch (e) {
                    await new Promise(resolve => {
                        this.is_loading = false;
                        resolve();
                    });
                }
            }
        },
        search_core_waybill() {
            return axios.post(
                'https://api.tw568.com/v1/guest/38a3657dc90d6d03-28036-39768292/core_waybills/search',
                {
                    number: this.current_number
                }
            ).then(res => {
                if (res.data.status == 'success') {
                    this.core_waybill = res.data.core_waybill;
                }
            }).catch(err => {
                this.error = err;
                console.log(err);
            });
        },
        search_by_express_core_waybill() {
            if (this.core_waybill) {
                return axios.post(
                    'https://api.tw568.com/v1/customer/core_waybills/search',
                    {
                        number: this.current_number
                    },
                    {
                        headers: { Authorization: "eyJhbGciOiJIUzI1NiJ9.eyJwcm92aWRlcl9ub2RlX2lkZW50aXR5IjoiNjg5NmJkNjVjMS0yODAzNi0zOTc2ODI5MiIsImN1c3RvbWVyX2lkZW50aXR5IjoiZDhjMjZlNTQxMC0yODAzNi0zNjI2Njk4ODU5MzIyNCIsInN0YWZmX2lkZW50aXR5IjpudWxsLCJzdGF0aW9uX2lkZW50aXR5IjpudWxsLCJjb250cmFjdF9pZGVudGl0eSI6bnVsbCwicm9sZSI6ImN1c3RvbWVyIn0.MsQG5-WJsDxpX7GMZkWfzOHnG23_4AJqMln1tscNbnA" }
                    }
                ).then(res => {
                    if (res.data.status == 'success') {
                        let by_express_statuses = res.data.core_waybill.statuses;
                        this.core_waybill.statuses = this.core_waybill.statuses.concat(by_express_statuses);
                    }
                }).catch(err => {
                    this.error = err;
                    console.log(err);
                });
            } else {
                return axios.post(
                    'https://api.tw568.com/v1/customer/core_waybills/search',
                    {
                        number: this.current_number
                    },
                    {
                        headers: { Authorization: "eyJhbGciOiJIUzI1NiJ9.eyJwcm92aWRlcl9ub2RlX2lkZW50aXR5IjoiNjg5NmJkNjVjMS0yODAzNi0zOTc2ODI5MiIsImN1c3RvbWVyX2lkZW50aXR5IjoiZDhjMjZlNTQxMC0yODAzNi0zNjI2Njk4ODU5MzIyNCIsInN0YWZmX2lkZW50aXR5IjpudWxsLCJzdGF0aW9uX2lkZW50aXR5IjpudWxsLCJjb250cmFjdF9pZGVudGl0eSI6bnVsbCwicm9sZSI6ImN1c3RvbWVyIn0.MsQG5-WJsDxpX7GMZkWfzOHnG23_4AJqMln1tscNbnA" }
                    }
                ).then(res => {
                    if (res.data.status == 'success') {
                        this.core_waybill = res.data.core_waybill;
                    } else {
                        return Promise.reject(res.data.errors);
                    }
                }).catch(err => {
                    switch (err) {
                        case "CoreWaybill not found":
                        case "CoreWaybill not found.":
                            this.error = "查無單號";
                            console.log("CoreWaybill not found");
                            break;
                        default:
                            this.error = err;
                            console.log(err);
                    }
                });
            }
        },
        toggle_current_number(number) {
            if (this.current_number != number) {
                this.current_number = number;
                this.search();
            }
        },
        reset_searched_numbers() {
            this.searched_numbers = [];
        },
        human_time(time) {
            return moment(time).locale("zh-tw").format("lll");
        }
    }
}
</script>

<style scoped>
.footer {
    color: #024287;
    font-size: 20px;
    border-top: 1px solid #abcfdb;
    padding: 10px;
    margin-top: 20px;
}
.footer a {
    color: #024287;
}
.search{max-width: 400px; margin:0 auto;}
.search input[type=text]{border-radius: 10px; padding:10px;margin: 10px 0 30px 0;width: 100%; border:solid 1px #004089;}
.input { margin: 0 0 25px 0;}
.input input[type=submit] {width: 100%;margin: 0;}
.input p{border-bottom: solid 1px #ccc; text-align: center; font-size: 16px; flex:2;}
.input span{width:80px; font-size: 16px; letter-spacing: 2px;}

.search-con{margin-top: 50px; position: relative;}
.search-l{margin-right:235px; border:solid 1px #333;  }
.table-line{padding-top: 5px; border-top: solid 1px #333; }
.search-r{position: absolute;right: 0; top: 0;width: 200px; border:solid 1px #333;}
.search-r .item{min-height: 250px;}
.search-r .item a{display: block; text-align: center; margin: 2px 0;}
.search-r .item a:hover{background: #ff6666; color: #fff;}
.reset{background: #004089; border-radius: 50px;padding: 12px; color: #fff;margin-bottom: -70px;cursor: pointer;  text-align: center;}
h1.header {
    color: #024287;
    font-size: 30px;
    border-bottom: 1px solid #ABCFDB;
    padding: 0px 10px 15px 45px;
    margin-bottom: 20px;
    background: url('../assets/images/pgs_header_icon.png') no-repeat;
}

h2.t,h4.t{background: #003398;text-align: center; color: #fff; padding:8px;}
.c{max-width: 320px;margin: 30px auto;}
table{width: 100%;text-align: center;    border-spacing: 0;  border-collapse: collapse; }
table thead th{position: relative; border-top:solid #333 1px; border-bottom:solid #333 1px; padding:5px; background: #f0f0f0;}
table thead th:after{ position: absolute; width: 1px; height: 60%; right: -1px; top: 20%; background: #333; content: "";z-index: 2;}
table thead th:last-child:after{width: 0px;}
table tr td{ border-bottom: 1px solid #ddd;border-right: 1px solid #ddd; padding:5px;}
table tr td:last-child{ border-right: 0px solid #ddd; }
.pointer {
    cursor: pointer;
}
.inline {
    display: inline;
}
@media only screen and (max-width: 767px){
  h2.t{font-size: 18px;}
  .table-line{overflow-x: scroll;}
  table thead th,table tr td{ word-break: keep-all;white-space:nowrap;  }

.search-l{margin-right:0;  }
.search-r{position: relative;width: 100%;margin-top: 30px;}
.search-r .item{min-height: 50px;}
.reset{margin: 10px;}

}
</style>



// WEBPACK FOOTER //
// src/components/search.vue